module.exports = __webpack_public_path__ + "img/plus.4bd86eab.svg";